module.exports = __webpack_public_path__ + "img/145.f663ca30.jpg";